import request from '../../request';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { URL, PARAM } from '../../../constants/reading/ApiConstants';

const { BURST_STUDENTS_ENROLLMENT_INFO, BURST_STUDENTS_DATA } = URL.BURST;
const { BURST_GROUP_ID, INST_UID, STUDENT_IDS } = PARAM;

class BurstClient {
    static getBurstStudents = group => {
        const urlWithQueryParams = constructUrlObject(BURST_STUDENTS_ENROLLMENT_INFO, {
            [BURST_GROUP_ID]: group,
        });
        return request.get(urlWithQueryParams);
    };

    static getInterventions = (studentIds, school) => {
        const urlWithQueryParams = constructUrlObject(BURST_STUDENTS_DATA, {
            [STUDENT_IDS]: studentIds ? studentIds.join() : '',
            [INST_UID]: school,
        });
        return request.get(urlWithQueryParams);
    };
}

export default BurstClient;
